import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { type PillVariants, pillVariants } from './pill-variants';

type PillProps = PillVariants & {
  children: ReactNode;
  hasDot?: boolean;
  isLive?: boolean;
  className?: string;
};

export function Pill({
  tone,
  size,
  hasDot = false,
  isLive = false,
  className,
  children,
}: PillProps) {
  return (
    <span data-slot="pill" className={cn(pillVariants({ tone, size }), className)}>
      {hasDot ? (
        <span
          aria-hidden="true"
          className={cn('size-1.5 rounded-full bg-current', isLive && 'motion-safe:animate-live')}
        />
      ) : null}
      {children}
    </span>
  );
}
